import React from "react"

import { Box } from "components/common"

const SizeVideo = () => (
  <Box
    as="video"
    controls
    poster={require("images/info/ring_sizing/ring_size_video_thumb.jpg")}
    preload="none"
    width="100%"
  >
    <source
      src="https://assets.jewlr.com/ring_sizing/ring_sizing_video.mp4"
      type="video/mp4"
    />
    <source
      src="https://assets.jewlr.com/ring_sizing/ring_sizing_video.webm"
      type="video/webm"
    />
    <source
      src="https://assets.jewlr.com/ring_sizing/ring_sizing_video.ogv"
      type="video/ogv"
    />
  </Box>
)

export default SizeVideo
